import { NfStatus } from './models/nf-status.enum';

export class NfDetailsLoad {
  static readonly type = '[NfDetails] Load';
  constructor(public id: number) {}
}

export class NfDetailsReset {
  static readonly type = '[NfDetails] Reset';
}

export class NfDetailsUpdateStatus {
  static readonly type = '[NfDetails] Update Status';
  constructor(public id: number, public status: NfStatus) {}
}
